// extracted by mini-css-extract-plugin
module.exports =  {"ImageBackgroundHolder":"ImageBackgroundHolder__2Ld-6"};